import DataroomEmailAlerts from './DataroomEmailAlerts';

export default DataroomEmailAlerts;
